export default "__VITE_ASSET__C6A7NQ2J__"